angular.module('console')
.controller('PracticeConsoleController', ['$scope', '$stateParams', '$state', 'Logger', 'ConsoleHelper', '$uibModal', 'ModalHandler', 'Notification', 'ProviderInvitation', 'User', '$rootScope', 'Address', 'Procedure', 'Practice', 'Designation', 'Impersonation', 'ImpersonationState', 'Auth', 'StateLicenseService', 'EmailSuppressionWarning', 'TrialExpiryWarning', 'AccountSetupActions', 'CustomBranding', 'ConfirmDialog', '$filter',
    function($scope, $stateParams, $state, Logger, ConsoleHelper, $uibModal, ModalHandler, Notification, ProviderInvitation, User, $rootScope, Address, Procedure, Practice, Designation, Impersonation, ImpersonationState, Auth, StateLicenseService, EmailSuppressionWarning, TrialExpiryWarning, AccountSetupActions, CustomBranding, ConfirmDialog, $filter) {
        $scope.practiceTypes = Procedure.practiceTypes();
        $scope.StateLicenseService = StateLicenseService;
        $scope.practiceDesignations = Designation.getAll();
        $scope.onPracticeSelected = ConsoleHelper.onPracticeSelected($scope);
        $scope.findPractice = ConsoleHelper.findPractice($scope);

        $scope.showFullRole = ConsoleHelper.showFullRole();

        $scope.showUserSpecialty = ConsoleHelper.showUserSpecialty($scope.practiceTypes);

        var selectedPracticeId = $stateParams.practice;
        var selectedInvitationId = $stateParams.invitation;

        if(selectedInvitationId && !selectedPracticeId) {
            // Load invitation details and initialize invitation view
            ProviderInvitation.get({ id: selectedInvitationId }, function(invitation){
                var invitationContainer = { users: [invitation], name: '-- pending registration --', isInvitation: true };
                $scope.onPracticeSelected(invitationContainer);
                $scope.practiceSearch = invitationContainer; // show in typeahead input
            }, function(){
                Notification.error('An error occurred during get invitation...');
            });
        } else if(selectedPracticeId) {
            Practice.get({practiceId: selectedPracticeId}, function(practice){
                $scope.practiceSearch = practice;
                $scope.onPracticeSelected(practice);
            }, function(failure){
                Notification.error('An error occurred during get practice...');
            });
            Practice.getStats({practiceId: selectedPracticeId}, function(success){
                $scope.practiceStats = success;
            }, function(error) {
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load practice stats', error);
                }
            });
            loadSentEmails(selectedPracticeId);
        }

        // DCL-605: the latest campaign emails this practice was sent (the
        // server caps the list at five, newest first).
        function loadSentEmails(practiceId) {
            $scope.sentEmails = {loading: true, items: [], failed: false};
            Practice.getSentEmails({practiceId: practiceId}, function(emails) {
                if (String(practiceId) !== String(selectedPracticeId)) {
                    return; // another practice was picked while this loaded
                }
                $scope.sentEmails = {loading: false, items: emails, failed: false};
            }, function(error) {
                if (String(practiceId) !== String(selectedPracticeId)) {
                    return;
                }
                $scope.sentEmails = {loading: false, items: [], failed: true};
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load sent emails', error);
                }
            });
        }

        $scope.viewSentEmail = function(email) {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/console_sent_email_modal.html',
                controller: 'SentEmailModalController',
                size: 'lg',
                resolve: {
                    practiceId: function() {
                        return selectedPracticeId;
                    },
                    sentEmail: function() {
                        return email;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.catch(function () {
                // dismissed
            });
        };

        // Initialize selected user from URL if provided
        // Note: we keep this value up-to-date when the user dropdown changes so reloading the list
        // (e.g. after closing Edit User modal) can re-select the correct user object instance.
        var selectedUserId = $stateParams.user;
        $scope.$watch('destinationPracticeUsers', function(users) {
            if (users && users.length) {
                var desiredId = selectedUserId || ($scope.practiceUser && $scope.practiceUser.id);
                var target = null;

                if (desiredId) {
                    for (var i = 0; i < users.length; i++) {
                        if (String(users[i].id) === String(desiredId)) {
                            target = users[i];
                            break;
                        }
                    }
                }

                if (target) {
                    $scope.practiceUser = target;
                } else if (!$scope.practiceUser) {
                    // Default to first user when list loads and nothing is selected yet
                    $scope.practiceUser = users[0];
                }
            }
        });

        function refreshDestinationPracticeUsersAndReselect() {
            // Only applies to real practices (invitation view doesn't support editing users)
            if (!$scope.destinationPractice || !$scope.destinationPractice.id) {
                return;
            }

            // Ensure we always reselect the currently shown user after the list is refreshed.
            if (!selectedUserId && $scope.practiceUser && $scope.practiceUser.id) {
                selectedUserId = $scope.practiceUser.id;
            }

            // Re-fetch users list; this updates roles_mask so ROLE display updates immediately.
            $scope.onPracticeSelected($scope.destinationPractice);
        }

        $scope.editDialog = function(editUser){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/edit_user_form.html',
                controller: 'EditUserModalController',
                resolve: {
                    editUser: function () {
                        return editUser;
                    },
                    practiceType: function(){
                        return $scope.destinationPractice.practice_type;
                    },
                    practiceAddresses: function(){
                        return $scope.destinationPractice.addresses;
                    },
                    nameEditable: function(){
                        return true;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.finally(function () {
                refreshDestinationPracticeUsersAndReselect();
            });
        };

        $scope.confirmDeleteUser = function (user) {
            var invited = user.status === 'invited';
            var name = [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email;

            ConfirmDialog.open(invited ? {
                title: 'Delete this invitation?',
                message: 'The invitation to ' + name + ' will be cancelled.',
                confirmText: 'Delete invitation'
            } : {
                title: 'Delete this user?',
                message: name + ' will be removed from this practice.',
                confirmText: 'Delete user'
            }).then(function (confirmed) {
                if (confirmed) {
                    $scope.deleteUser(user);
                }
            });
        };

        $scope.deleteUser = function (user) {
            if (user.status && user.status === 'invited') {
                ProviderInvitation.delete({id: user.id}, function (success) {
                        if(success.msg){
                            Notification.error(success.msg);
                        }else{
                            if ($scope.destinationPractice.isInvitation) {
                                $scope.destinationPractice = {};
                                $scope.practiceSearch = '';
                            } else {
                                $scope.destinationPracticeUsers.splice($scope.destinationPracticeUsers.indexOf(user), 1);
                            }
                        }
                    },
                    function (failure) {
                        Notification.error('An error occurred during invitation removal...')
                    });

            } else if (user.status && user.status === 'registered') {
                User.delete({id: user.id}, function (success) {
                        if (success.msg) {
                            Notification.error(success.msg)
                        } else {
                            $scope.destinationPracticeUsers.splice($scope.destinationPracticeUsers.indexOf(user), 1);
                        }
                    },
                    function (failure) {
                        // DCL-571: removal can be refused (last admin) with a
                        // message worth showing over the generic line.
                        Notification.error((failure.data && failure.data.message) ||
                            'An error occurred during user removal...');
                    });
            }
        };

        $scope.onUserChanged = function(user) {
            var userId = user && user.id ? user.id : null;
            selectedUserId = userId;
            if (selectedPracticeId) {
                $state.go('console.practice', { practice: selectedPracticeId, user: userId }, { notify: false, location: 'replace' });
            } else if ($scope.destinationPractice && $scope.destinationPractice.isInvitation) {
                var invitationId = ($scope.practiceUser && $scope.practiceUser.id) ? $scope.practiceUser.id : (selectedInvitationId || null);
                $state.go('console.practice', { invitation: invitationId }, { notify: false, location: 'replace' });
            }
        };

        $scope.usersDialog = function () {
            var scope = $rootScope.$new();
            scope.params = {
                practiceId: $scope.destinationPractice.id
            };

            var modalInstance = $uibModal.open({
                templateUrl: 'partials/user_form.html',
                controller: 'UserModalController',
                resolve: {
                    practiceTypes: function () {
                        return $scope.practiceTypes;
                    },
                    practice: function () {
                        return $scope.destinationPractice;
                    }
                },
                scope: scope
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (user) {
                $scope.destinationPracticeUsers.push(user);
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.addAddress = function () {
            if ($scope.practiceSearch.addresses.length < 20) {
                $scope.practiceSearch.addresses.push({new: true, _isOpen: true});
            }
        };

        // The delete runs now, not when the section is saved, and an unsaved row
        // has nothing to lose, so it goes without asking.
        $scope.confirmRemoveAddress = function (address, addressForm) {
            if (address.new) {
                $scope.removeAddress(address);
                return;
            }

            // The form edits the address in place, so once it's dirty these fields
            // may not be what's stored. The accordion heading shows the same number.
            var saved = addressForm && addressForm.$dirty ? '' : $filter('fullAddress')(address);
            var name = saved || 'Address #' + ($scope.practiceSearch.addresses.indexOf(address) + 1);

            ConfirmDialog.open({
                title: 'Delete this address?',
                message: name + ' will be removed from this practice right away.',
                confirmText: 'Delete address'
            }).then(function (confirmed) {
                if (confirmed) {
                    $scope.removeAddress(address);
                }
            });
        };

        $scope.removeAddress = function(address){
            function removeFromList() {
                $scope.practiceSearch.addresses.splice($scope.practiceSearch.addresses.indexOf(address),1);
            }

            if(address.new){
                removeFromList();
            } else {
                Address.delete({id: address.id}, function(success){
                    removeFromList();
                    Notification.success('Address delete success');
                }, function(failure){
                    // A 404 means it's already gone, so the row should go too.
                    if (failure.status === 404) {
                        removeFromList();
                        return;
                    }
                    Notification.error('Address delete fail');
                });
            }
        };
        $scope.selectPractice = function(practice){
            $scope.onPracticeSelected(practice);
            if (practice && practice.id) {
                Practice.getStats({practiceId: practice.id}, function(success){
                    $scope.practiceStats = success;
                });
                selectedPracticeId = practice.id;
                loadSentEmails(practice.id);
                $state.go('console.practice', { practice: practice.id, user: selectedUserId }, { notify: false, location: 'replace' });
            } else if (practice && practice.isInvitation && practice.users && practice.users[0]) {
                // Invitation selected: reflect invitation id in URL
                selectedPracticeId = null;
                $scope.sentEmails = null;
                selectedInvitationId = practice.users[0].id;
                $state.go('console.practice', { invitation: selectedInvitationId }, { notify: false, location: 'replace' });
            }
        };

        $scope.saveAddress = function(addressForm, address) {
            if (addressForm.$dirty && !addressForm.$invalid) {
                if(!address.new) {
                    Address.update({id: address.id}, address, function(success){
                        Notification.success('Address save success');
                    }, function(failure){
                        Notification.error('Address save fail');
                    });
                } else {
                    address.practice_id = $scope.practiceSearch.id;
                    Address.save({address: address}, function(success){
                        var index = $scope.practiceSearch.addresses.indexOf(address);
                        $scope.practiceSearch.addresses[index] = JSON.parse(JSON.stringify(success));
                        $scope.practiceSearch.addresses[index]._isOpen = true;
                        Notification.success('Address create success');
                    }, function(failure){
                        Notification.error('Address create fail');
                    });
                }
            }
        };

        $scope.savePractice = function(practiceForm, destinationPractice){
            if (practiceForm.$dirty && !practiceForm.$invalid) {
                destinationPractice.practice_type_id = destinationPractice.practice_type.id;
                destinationPractice.designation_id = destinationPractice.designation ? destinationPractice.designation.id : null;
                destinationPractice.addresses_attributes = destinationPractice.addresses;
                Practice.update({practiceId: destinationPractice.id}, {practice: destinationPractice}, function (success) {
                    $scope.destinationPractice = $scope.practiceSearch = success;
                    Notification.success('Practice update success');
                }, function (failure) {
                    Notification.error(failure.data.message ? failure.data.message : 'Practice update fail');
                });
            }
        };

        $scope.removePractice = function(practice){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/practice_delete_form.html',
                controller: 'PracticeDeleteModalController',
                resolve: {
                    selectedPractice: function(){
                        return practice;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (error) {
                $scope.destinationPractice = $scope.destinationPracticeUsers = $scope.practiceSearch = '';
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.inviteDialog = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/provider_form.html',
                controller: 'ProviderModalController',
                resolve: {
                    dependsOnReferral: function() {
                        return false;
                    },
                    inviterId: function() {
                        return $scope.practiceUser.id;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (provider) {
                Notification.success('Provider invitation was sent successfully');
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.approvePractice = function(practice) {
            Practice.updateStatus({practiceId: practice.id}, {status: 'approved'},
                function(success){
                    $scope.destinationPractice.status = success.status;
                    Notification.success('Practice has been approved successfully');
                }, function(failure){
                    Notification.error(failure.data.message)
                });
        };

        $scope.startImpersonation = function(user) {
            if (!user || !user.id) {
                Notification.warning('Please select a user to impersonate');
                return;
            }
            
            Impersonation.start({user_id: user.id}, function(response) {
                // DCL-462: $state.go(..., {reload: true}) below is a state reload,
                // not a page reload, so the super user's suppression toast and the
                // service's once-per-session flag would both carry into the
                // impersonated session. Clear them before the identity changes.
                EmailSuppressionWarning.reset();
                TrialExpiryWarning.reset(); // DCL-507: same leak, same fix
                // DCL-643: a setup check deferred on the console would
                // otherwise run for the impersonated practice.
                AccountSetupActions.reset();
                Notification.dismiss();
                // Update auth context with impersonated user
                Auth.set({
                    email: response.email,
                    roles: response.roles,
                    id: response.id,
                    practice_id: response.practice_id
                });
                // DCL-286: branding is the super user's own until something
                // changes it, and the reload below is a state reload, so
                // nothing re-reads the branding cookie. Switch to the
                // impersonated practice's branding as its details arrive.
                Auth.current_user = User.get({id: response.id}, function(impersonatedUser) {
                    CustomBranding.applyForUser(impersonatedUser);
                });
                ImpersonationState.notifyChange();
                $state.go('history', {}, {reload: true});
            }, function(error) {
                Notification.error('Failed to start impersonation');
            });
        };
    }]);
